"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganisationRepository = void 0;
class OrganisationRepository {
    constructor(client) {
        this.clientWithRetry = client.clientWithRetry;
        this.clientWithoutRetry = client.clientWithoutRetry;
    }
    create(quoteId, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.clientWithoutRetry.post('/organisations', { password: password, quoteId: quoteId });
        });
    }
    update(_a) {
        return __awaiter(this, arguments, void 0, function* ({ quoteId, token, sendEmail, parentClusterNodeId, }) {
            return this.clientWithoutRetry.post('/organisations', {
                parentClusterNodeId,
                quoteId,
                sendEmail,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
        });
    }
    getChargebeeIds(organisationId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithRetry.get(`/client/organisations/${organisationId}/chargebee_ids`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return data;
        });
    }
    getContractDetails(organisationId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithoutRetry.get(`/organisations/${organisationId}/contract_details`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return data;
        });
    }
    requestSalesforceDelete(id, token) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.clientWithoutRetry.delete(`/requests/organisations/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
        });
    }
    createQuoteByOrgaId(id, firstName, lastName, email, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithoutRetry.post('/quote', {
                organisationId: id,
                userEmail: email,
                userFirstName: firstName,
                userLastName: lastName,
            }, { headers: { Authorization: `Bearer ${token}` } });
            return data;
        });
    }
    startContractChange(quoteId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.clientWithoutRetry.post('/organisations/start_contract_change', { quoteId: quoteId });
        });
    }
}
exports.OrganisationRepository = OrganisationRepository;
//# sourceMappingURL=OrganisationRepository.js.map